export default __webpack_public_path__ + "static/media/logo-white.a667b709.svg";